import { render, staticRenderFns } from "./ListSpeaker.vue?vue&type=template&id=4d06df8d"
import script from "./ListSpeaker.vue?vue&type=script&lang=js"
export * from "./ListSpeaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports